import { CreditCardType } from '@anm/api/modules/subscription';

const cardTypeMap: { [key: string]: string } = {
  'american express': 'amex',
  'diners club': 'diners'
};

const mapCardType = (cardType: string) => {
  const mappedCardType = cardTypeMap[cardType] || cardType;
  return mappedCardType.toLowerCase() as CreditCardType;
};

export default mapCardType;
